import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase project configuration for Smile Analyst
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBIQ24WDimDT45K6OirNHPYu8qwKSjufdI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "smile-analyst.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "smile-analyst",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "smile-analyst.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "652760216500",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:652760216500:web:12d7daba142aa81ce7f8e1",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-3EK3MYT76W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Export app instance
export default app;
